import React, { FC } from 'react'
import S from './ModelButton.styles'

interface ModelButtonProps {
  /** The text to render */
  text: string
  /** The image to render */
  img: string
  /** Callback to be invoked on click */
  onClick?: () => void
}

const ModelButton: FC<ModelButtonProps> = ({ text, img, onClick }) => {
  const handleClick = () => {
    if (onClick) {
      onClick()
    }
  }

  return (
    <S.ModelButton type="button" onClick={handleClick}>
      <img src={img} alt={text} />
      <span>{text}</span>
    </S.ModelButton>
  )
}

export default ModelButton
